module.exports = __webpack_public_path__ + "media/images/logo-696856e63d110cd279ebab4b1919c105.png";